import React from "react";
import styled, { css, isStyledComponent } from 'styled-components';
import { Button } from "xsolla-uikit";
import { Link } from 'react-router-dom';
export const VersionButton = ({ version = 'poydo', stateUpdater }) => {
  const [state, setState] = React.useState(version);
  return (
    <CSSvers0>
      <CSSvers>

      PA version:&nbsp;

        <CSSversBut active={state === "poydo" ? true : false}>
        <a href='#' appearance="flatten"
          // disabled={state === "poydo" ? true : false}
          style={{ color: state === "poydo" ? 'blue' : '#777' }} onClick={e => {
            stateUpdater("poydo");
            setState("poydo");
          }}>
          {`  `}<b>Current</b>{`  `}
        </a>
      </CSSversBut>

        &nbsp;&nbsp;

        <CSSversBut active={state === "poydo" ? true : false}>
        <a href='#' appearance="flatten"
          // disabled={state === "misha" ? true : false}
          style={{ color: state === "misha" ? 'blue' : '#777' }} onClick={e => {
            stateUpdater("misha");
            setState("misha");
          }}>
          {`  `}<b>New PA</b>{`  `}
        </a>
      </CSSversBut>

      </CSSvers>


      <CSSvers>

        <a target="_blank" href='https://xsolla-solutions.netlify.app/'>Solutions Catalogue ↗︎</a>

      </CSSvers>


      <CSSright>
        <img src='https://api.netlify.com/api/v1/badges/f8fb982b-c0bd-482c-b69c-a5d550d9dc45/deploy-status'/>
      </CSSright>



  </CSSvers0>);
};





export const CSSversBut = styled.div`

  @media(max-width: 768px) {
    ${(active)=> active && css`
      display: none
    `}
  }
`


export const CSSvers = styled.div`
  display: flex;
  padding: 0 24px;
  border-right: 1px solid currentColor;
  &:last-child{
    border-right: none;
  }
`

export const CSSright = styled.div`
  display: flex;
  flex-grow: 1;
  /* padding: 0 24px; */
  justify-content: flex-end;
`


export const CSSvers0 = styled.div`
  opacity: 0.4;
  display: flex;
  font-size: 13px;
  position: fixed;
  bottom: 0px;
  right: 0;
  z-index: 1000;
  width: 100%;
  padding: 4px 16px;
  background: #c5d0db;
  /* opacity: 0.5; */
  /* border-radius: 4px; */

  @media(max-width: 768px) {
    margin-left: -70px;
    margin-top: -110px;
    transform: scale(0.5);
    padding: 8px;
  }
`
